export default __webpack_public_path__ + "static/media/landing-page-img-mobile.0eb399db.webp";